import { render, staticRenderFns } from "./PunchSet.vue?vue&type=template&id=b1f0553c&scoped=true&"
import script from "./PunchSet.vue?vue&type=script&lang=js&"
export * from "./PunchSet.vue?vue&type=script&lang=js&"
import style0 from "./PunchSet.vue?vue&type=style&index=0&id=b1f0553c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f0553c",
  null
  
)

export default component.exports